import { render, staticRenderFns } from "./prefixEditTabInformation.vue?vue&type=template&id=122dcf2b&scoped=true&"
import script from "./prefixEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./prefixEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./prefixEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122dcf2b",
  null
  
)

export default component.exports